import { Controller } from "@hotwired/stimulus";
import Chart from 'chart.js/auto';
import ChartDataLabels from "chartjs-plugin-datalabels";

export default class UserBarChartController extends Controller {
    connect() {
        let labels = JSON.parse(this.element.dataset.labels);
        let regUsers = JSON.parse(this.element.dataset.regUsers);
        let activeUsers = JSON.parse(this.element.dataset.activeUsers);

        this.chart = new Chart(
            this.element,
            {
                type: 'bar',
                plugins: [ChartDataLabels],
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Registered Users',
                            data: regUsers
                        },
                        {
                            label: 'Active Users',
                            data: activeUsers
                        }
                    ]
                }
            }
        );
    }
}
